(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var navItems = document.querySelectorAll('.vertical-tabs-nav-item');
    var panels = document.querySelectorAll('.vertical-tabs-panel');
    navItems.forEach(function(item) {
      item.addEventListener('click', function() {
        var tabNumber = this.getAttribute('data-tab');
        navItems.forEach(function(n) { n.classList.remove('active'); n.setAttribute('aria-selected','false'); });
        panels.forEach(function(p) { p.classList.remove('active'); });
        this.classList.add('active');
        this.setAttribute('aria-selected','true');
        document.getElementById('panel-' + tabNumber).classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
